import Length from "./Length";
import Rectangle from "./Rectangle";
import CircleFraction from "./CircleFraction";

export default class Circle extends CircleFraction {
	static NAME = "circle";

	get_name() {
		return Circle.NAME;
	}

	get_enclosing_rectangle() {
		const length = new Length( this.diameter.in_mm() );
		const width = new Length( this.diameter.in_mm() );
		return new Rectangle( length, width );
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			diameter: maximum_rectangle.get_shortest_side()
		};
	}

	get_fraction() {
		return 1;
	}
}
